import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { change, formValueSelector, reduxForm } from 'redux-form';
import { Button, Form } from 'reactstrap';
import { connect } from 'react-redux';

import DynamicForm from '../../../common/forms/DynamicForm';
import FormFooter from '../../../common/forms/FormFooter';
import { EDIT_ITINERARY_SUPPLIER_FOOD_COLUMNS } from '../../../../config/dynamicFormFields';

const FORM_NAME = 'EditItinerarySupplierFoodForm';

const selector = formValueSelector(FORM_NAME);

const EditItinerarySupplierFoodForm = ({
  handleSubmit,
  handleProcess,
  onCancel,
  loading,
  itinerarySupplierFoodDetailList,
  dispatchChange,
}) => {
  const previousValuesRef = useRef(null);

  useEffect(() => {
    if (
      !itinerarySupplierFoodDetailList ||
      itinerarySupplierFoodDetailList.length === 0
    ) {
      previousValuesRef.current = null;
      return;
    }

    const currentValues = itinerarySupplierFoodDetailList.map((item) => ({
      quantity: item.quantity,
      unitCost: item.unitCost,
    }));

    if (previousValuesRef.current === null) {
      previousValuesRef.current = currentValues;
      return;
    }

    itinerarySupplierFoodDetailList.forEach((item, index) => {
      const previousValue = previousValuesRef.current[index];

      if (!previousValue) return;

      const quantityChanged =
        String(previousValue.quantity) !== String(item.quantity);

      const unitCostChanged =
        String(previousValue.unitCost) !== String(item.unitCost);

      if (!quantityChanged && !unitCostChanged) {
        return;
      }

      const quantity = Number(item.quantity);
      const unitCost = Number(item.unitCost);

      const validQuantity =
        item.quantity !== null &&
        item.quantity !== undefined &&
        item.quantity !== '' &&
        !Number.isNaN(quantity);

      const validUnitCost =
        item.unitCost !== null &&
        item.unitCost !== undefined &&
        item.unitCost !== '' &&
        !Number.isNaN(unitCost);

      const newTotal =
        validQuantity && validUnitCost
          ? Number((quantity * unitCost).toFixed(2))
          : null;

      dispatchChange(
        FORM_NAME,
        `itinerarySupplierFoodDetailList[${index}].cost`,
        newTotal,
      );
    });

    previousValuesRef.current = currentValues;
  }, [itinerarySupplierFoodDetailList, dispatchChange]);

  return (
    <Form onSubmit={handleSubmit(handleProcess)}>
      <h4>Detalle de alimentación</h4>

      <DynamicForm
        name="itinerarySupplierFoodDetailList"
        columns={EDIT_ITINERARY_SUPPLIER_FOOD_COLUMNS}
        showAddButton={false}
        showRemoveButton={false}
        labelWithoutElements="Sin detalle de alimentación"
      />

      <FormFooter
        saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-save'}
        saveButtonDisabled={loading}
      >
        <Button
          type="button"
          color="danger"
          onClick={onCancel}
          disabled={loading}
        >
          Cancelar
        </Button>
      </FormFooter>
    </Form>
  );
};

EditItinerarySupplierFoodForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleProcess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool,

  itinerarySupplierFoodDetailList: PropTypes.arrayOf(
    PropTypes.shape({
      quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      unitCost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      cost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),

  dispatchChange: PropTypes.func.isRequired,
};

EditItinerarySupplierFoodForm.defaultProps = {
  loading: false,
  itinerarySupplierFoodDetailList: [],
};

const mapStateToProps = (state) => ({
  itinerarySupplierFoodDetailList:
    selector(state, 'itinerarySupplierFoodDetailList') || [],
});

const mapDispatchToProps = {
  dispatchChange: change,
};

const formComponent = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
})(EditItinerarySupplierFoodForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
